export const membershipDurationConstant = {
    30: "1 Month",
    90: "3 Month",
    365: "1 Year",
  };